const objectPrefix = "\\YHUB.OBJ\\";

export const getStorage = (item) => {
    let value = window.localStorage.getItem(item);

    if (value !== null && value.startsWith(objectPrefix)) {
        const json = value.replace(objectPrefix, "");
        value = JSON.parse(json);
    }

    return value;
};

export const setStorage = (item, value) => {
    if (typeof value === "object") {
        value = objectPrefix + JSON.stringify(value);
    }

    window.localStorage.setItem(item, value);
};

export const unsetStorage = (item) => {
    window.localStorage.removeItem(item);
};

export default { getStorage, setStorage, unsetStorage };
